import { createSelector } from '@reduxjs/toolkit';
import { selectLocation } from 'shared/selectors/location';
import { getLocationIdForMetro } from 'shared/utils/underground';

export const selectLocationIdForMetroMap = createSelector(selectLocation, location => getLocationIdForMetro(location));
